/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Irrigation_Settings_Card_DescInputs */

const vi_smartlab_irrigation_settings_card_desc = /** @type {(inputs: Smartlab_Irrigation_Settings_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản API tưới của SmartLab dùng để đọc thông số cảm biến và trạng thái bơm của các bộ phun nước. Tài khoản này do SmartLab cấp riêng, khác tài khoản máy vò, camera và cân chè.`)
};

/**

* @param {Smartlab_Irrigation_Settings_Card_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_irrigation_settings_card_desc = /** @type {((inputs?: Smartlab_Irrigation_Settings_Card_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Irrigation_Settings_Card_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_irrigation_settings_card_desc(inputs)
});